import { SvgIcon } from '@material-ui/core'
import { React, withStyles } from '@api'

const styles = theme => ({
  icon: {
    width: theme.spacing() * 3,
    height: theme.spacing() * 3
  }
})
interface MyProps {
  className?: any
  classes?: any
  type?: any
}

const FileComponent = ({classes, type}: MyProps) => (
  <SvgIcon className={classes.icon} height={24} width={24} viewBox={'0 0 24 24'}>
    <path
      d={'M9 16h6v-6h4l-7-7-7 7h4zm-4 2h14v2H5z'}/>
  </SvgIcon>
)

export const FileUploadIcon : any = withStyles(styles)(FileComponent)



// WEBPACK FOOTER //
// ./src/shared/components/ui/icons/FileUploadIcon.tsx